import { useState } from "react";
import { signIn } from "../lib/auth";

export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      await signIn(email, password);
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="shell" style={{ maxWidth: 380, paddingTop: "18vh" }}>
      <p className="wordmark" style={{ fontSize: "2rem", marginBottom: 0 }}>thrifty<span>business</span></p>
      <p className="slogan" style={{ fontSize: "1rem" }}>Giving clothes a second chance</p>
      <p className="hint" style={{ marginTop: "1.25rem", marginBottom: "2rem" }}>
        Catalog a find, price it against the market, list it everywhere at once.
      </p>

      {error && <div className="notice">{error}</div>}

      <div className="field">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="field">
        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") void submit(); }}
        />
      </div>

      <button onClick={() => void submit()} disabled={busy || !email || !password} style={{ width: "100%" }}>
        {busy ? "Signing in" : "Sign in"}
      </button>

      <p className="hint" style={{ marginTop: "1.5rem" }}>
        Your session lives in this tab only. Closing it signs you out.
      </p>
    </div>
  );
}
